<nav aria-label="breadcrumb">
  <ol class="breadcrumb pmd-breadcrumb">
    <li
      [class]="'breadcrumb-item ' + (isLast ? 'active' : '')"
      aria-current="page"
      *ngFor="let breadcrumb of breadcrumbs$ | async; last as isLast"
    >
      <a tabindex="0" [routerLink]="breadcrumb.url" *ngIf="!isLast">
        {{ breadcrumb.label | translate }}
      </a>
      {{ isLast ? (breadcrumb.label | translate) : '' }}
    </li>
  </ol>
</nav>
